// Auto-select the second available option in grid variant pickers
// Runs without touching global.js and only acts when a grid picker is present

(function () {
  function selectSecondAvailableInGroup(groupElement) {
    if (!groupElement) return;

    const radios = Array.from(
      groupElement.querySelectorAll('input[type="radio"]:not(:disabled)')
    );

    if (radios.length < 2) return; // need at least two available choices

    const urlParams = new URLSearchParams(window.location.search);
    const urlHasVariant = urlParams.has('variant');

    // If URL explicitly sets a variant, do not override the selection
    if (urlHasVariant) return;

    const currentlyChecked = groupElement.querySelector('input[type="radio"]:checked');

    // Target is the second available radio
    const target = radios[1];

    // If already correctly selected, do nothing
    if (currentlyChecked === target) return;

    // Apply selection and notify listeners
    target.checked = true;
    target.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function runOnGridPickers(root) {
    // Scope to root or whole document
    const scope = root || document;

    // Prefer scoping per variant-selects component (one per product form area)
    const variantSelectsList = scope.querySelectorAll('variant-selects');
    if (variantSelectsList.length > 0) {
      variantSelectsList.forEach((vs) => {
        const groups = vs.querySelectorAll(
          '.product-form__input--grid [class^="image-variant-picker-"]'
        );
        if (groups.length > 0) {
          // Only act on the first option group
          selectSecondAvailableInGroup(groups[0]);
        }
      });
      return;
    }

    // Fallback: act on the first grid group in the page
    const firstGroup = scope.querySelector(
      '.product-form__input--grid [class^="image-variant-picker-"]'
    );
    if (firstGroup) selectSecondAvailableInGroup(firstGroup);
  }

  // Initial run when DOM is ready
  document.addEventListener('DOMContentLoaded', function () {
    // Only run on pages that actually have variant selects or product form
    const hasVariantSelects = document.querySelector('variant-selects');
    const hasGridPicker = document.querySelector('.product-form__input--grid');
    const hasProductForm = document.querySelector('form[action*="/cart/add"]');

    if (!hasProductForm || !hasGridPicker) return;

    runOnGridPickers(document);
  });

  // Also react when sections are dynamically loaded/updated in the theme editor
  document.addEventListener('shopify:section:load', function (event) {
    runOnGridPickers(event.target);
  });
})();

